import React from 'react';
import { useSelector } from 'react-redux';
import Divider from '@Components/Divider/Divider';
import Accordion from '@Components/Accordion/Accordion';
import FilePreview from '@Components/FilePreview/FilePreview';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import useTranslate from '@Utils/hooks/useTranslate';
import LabeledInformation from './LabeledInformation';
import { DocumentState } from '../../DocumentDetails/DocumentDetails';
import {
	AccordionContentWrapper,
	SectionHeader,
	DividerWrapper,
} from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

const ProvidedDocumentHBBWFBB = (): JSX.Element => {
	const { translate } = useTranslate();
	const hbbWfbbProcessCheckout = useSelector(
		(state: types.redux.IState) => state.persistentCheckout.hbbWfbbProcessCheckout
	);
	const getProvidedDocumentSubtitle = () =>
		translate(
			`shipping-details.accordion.provided.document.subtitle-${
				hbbWfbbProcessCheckout?.customerIdType === DocumentState.NATIONAL
					? DocumentState.NATIONAL
					: DocumentState.RESIDENCE
			}`,
			hbbWfbbProcessCheckout?.expiryDate || ''
		);

	return (
		<>
			<Accordion
				title={translate('shipping-details.accordion.provided.document')}
				subtitle={getProvidedDocumentSubtitle()}
				icon="document"
			>
				<AccordionContentWrapper>
					<SectionHeader>
						{translate(
							`shipping-details.accordion.provided-document.section-header-${
								hbbWfbbProcessCheckout?.customerIdType === DocumentState.NATIONAL
									? DocumentState.NATIONAL
									: DocumentState.RESIDENCE
							}`
						)}
					</SectionHeader>
					<Divider marginBottom={8} />
					<ConditionalRender
						show={!!hbbWfbbProcessCheckout?.expiryDate}
						onTrue={() => (
							<LabeledInformation
								label={translate('shipping-details.accordion.contact-data.data.expiry-date')}
								data={hbbWfbbProcessCheckout?.expiryDate}
							/>
						)}
					/>
					<Divider marginBottom={24} withoutLine />
					<SectionHeader>
						{translate(`shipping-details.accordion.provided-document.section-header-documents`)}
					</SectionHeader>
					<Divider marginBottom={8} />
					{(Object.keys(hbbWfbbProcessCheckout?.documentScan || {}) as (
						| 'base64backSide'
						| 'base64frontSide'
					)[]).map((key: 'base64backSide' | 'base64frontSide', index) => (
						<FilePreview
							key={`file-preview-${index}`}
							format={hbbWfbbProcessCheckout?.documentScan?.[key]?.type || ''}
							fileName={hbbWfbbProcessCheckout?.documentScan?.[key]?.name || ''}
							base64File={hbbWfbbProcessCheckout?.documentScan?.[key]?.base64File || ''}
						/>
					))}
				</AccordionContentWrapper>
			</Accordion>
			<DividerWrapper>
				<Divider />
			</DividerWrapper>
		</>
	);
};

export default ProvidedDocumentHBBWFBB;
